import(/* webpackMode: "eager" */ "/vercel/path0/frontend/lesson-platform/src/app/terms/page.tsx");
